var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreenshot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capturas",
    transform: "translate(-3 -2.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_fluent_screenshot_24_filled"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26504",
    "data-name": "Grupo 26504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "screen-capture-svgrepo-com",
    transform: "translate(1.2 1.199)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "secondary",
    cx: 3.6,
    cy: 3.6,
    r: 3.6,
    transform: "translate(7.2 7.2)",
    fill: "rgba(0,0,0,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M18.9,9a.9.9,0,0,1-.9-.9V3.6H13.5a.9.9,0,1,1,0-1.8H18a1.8,1.8,0,0,1,1.8,1.8V8.1A.9.9,0,0,1,18.9,9Zm.9,9V13.5a.9.9,0,1,0-1.8,0V18H13.5a.9.9,0,1,0,0,1.8H18A1.8,1.8,0,0,0,19.8,18ZM3.6,8.1V3.6H8.1a.9.9,0,1,0,0-1.8H3.6A1.8,1.8,0,0,0,1.8,3.6V8.1a.9.9,0,1,0,1.8,0ZM9,18.9a.9.9,0,0,0-.9-.9H3.6V13.5a.9.9,0,1,0-1.8,0V18a1.8,1.8,0,0,0,1.8,1.8H8.1A.9.9,0,0,0,9,18.9Z",
    fill: "#6fc186"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshot);
export default __webpack_public_path__ + "static/media/screenshot.0892c46630777ac251418259454bba7b.svg";
export { ForwardRef as ReactComponent };